var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 120,
    viewBox: "0 0 96 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Head"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Head",
    clipPath: "url(#clip-Head)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(-790.943 -275.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M803.3,355.119c-3.569-1.7-11.357.169-12.181-2.548-1.451-4.788,6.724-16.738,8.612-27.1,1.753-9.618-1.9-16.525,3.569-28.188s21.584-23.183,39.2-22.212,39.878,11.761,43.83,38.584c2.823,19.153-4.485,35.387-11.626,41.463s-12.475,13.5-10.809,35.855c0,5.345-34.172,4.484-35.84,2.538s1.428-17.5-.951-17.739-20.467,3.644-19.517-2.916.2-11.981-3.6-12.371C801.643,360.243,803.3,355.119,803.3,355.119Z",
    transform: "translate(0 0)",
    fill: "#5a9b73"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(817.177 302.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(23.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M819.593,324s12.572,1.213,17.4-14.8,8.021-19.71,8.021-19.71-.246-1.193-3.229.374-22.327,6.74-24.222,16.562S817.81,321.874,819.593,324Z",
    transform: "translate(-816.19 -289.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(0 9.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M817.8,323.082c-.236.086-.452-.148-.627-.328s-.52-.3-.638-.082a.452.452,0,0,0-.032.22l.1,6.287a45.726,45.726,0,0,0,.382,6.2.883.883,0,0,0,.294.637.833.833,0,0,0,.631.052,5.91,5.91,0,0,0,1.335-.432,1.2,1.2,0,0,0,.589-.46,1.334,1.334,0,0,0,.092-.717c-.164-2.994-.184-6-.058-9,.22-5.188,2.046-10.092,4-14.886,2.1-5.16,4.65-10.445,8.451-14.584.523-.572,1.87-1.615,1.3-2.136s-2.156.779-2.676,1.347c-8.671,9.442-13.365,27.693-13.589,28.519a1.349,1.349,0,0,0-.04.526,1.4,1.4,0,0,0,2.732.208,6.279,6.279,0,0,1,.128-2.822l.018-.074Z",
    transform: "translate(-816.507 -293.734)",
    fill: "#3f633b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M827.478,316.413s-7.774,3.127-13.845-6.161-8.8-11.043-8.8-11.043-.068-.8,2.124-.366,15.475.108,18.521,6S828.214,314.721,827.478,316.413Z",
    transform: "translate(-804.835 -279.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(9.102 23.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M825.5,317.113a.927.927,0,0,1-1.7.644,4.174,4.174,0,0,0-.611-1.773c-2-3.373-7.22-10.851-12.532-14.047-.44-.266-1.493-.677-1.229-1.115s1.517.092,1.956.356c7.288,4.386,13.7,15.122,13.992,15.607A.907.907,0,0,1,825.5,317.113Z",
    transform: "translate(-809.382 -300.654)",
    fill: "#3f633b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/Head.8911cb75e88fa9d7e6c073fe6e53024c.svg";
export { ForwardRef as ReactComponent };